/* eslint-disable jsx-a11y/heading-has-content */
/**
 * @file   图片详情页
 * @create macaiqi 2021/11/29
 * @update
 */
import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import 'swiper/swiper.scss';
import cls from 'classnames';
import './index.scss';
import BigImgShow from './BigImgShow';
import Relation from '../Relation/index';
import Slider from '@ant-design/react-slick';
import { GetQueryString } from '../../../../utils';
import {queryInstanceDetails,queryRecommendedImageList,queryGeosByInstanceId} from '../../../shared/api';
import markIcon from '@/assets/images/desktop/common/mark.png';
import dImg from '../../../../assets/images/desktop/common/defaultImg.jpg';
import fullscreenImg from '../../../../assets/images/desktop/imgdetail/fullscreen.png';
import markImg from '../../../../assets/images/desktop/common/markImg.png';
const ImgDetail = () => {
  const isInitImg =  false;
  const [selectedTab, setSelectedTab] = useState('basicInfo'); 
  const [init, setInit] = useState(true); 
  const tab = [{id:'basicInfo',text:'基本信息'},{id:'relationGraph',text:'关系图谱'},{id:'map',text:'地理位置'},{id:'resource',text:'其他影像'}]
  const [hasImg,setHasImg] = useState(true);   // 是否有影像探索模块
  const [hasMap,setHasMap] = useState(true);   // 是否有地理位置模块
  const { pathname } = useLocation();
  const instanceId = pathname.split('/').reverse()[0];
  const fileInfoId = GetQueryString('fileInfoId');
  const settings = {
    className: "slider variable-width",
    dots: false,
    infinite: false,
    centerMode: false,
    variableWidth: true,
    swipeToSlide: true,
  };
  const [imgs,setImgs] = useState([]);
  const [imgs1,setImgs1] = useState([]);
  const [instanceData,setInstanceData] = useState(null);  // 实例信息
  const pre = window.ENV_IMG_PREURL_SRC;
  const [map, setMap] = useState();
  const [centerPoint, setCenterPoint] = useState();
  useEffect(() => {
    getInstanceDetail();
  },[]);

  // 地图初始化
  useEffect(() => {
    setTimeout(()=>{
      map.enableScrollWheelZoom(true);
      queryGeosByInstanceId(instanceId).then((data)=>{
        if(data && data.length>0){
          setHasMap(true);
          // 设置中心点
          let geo = data?.[0].geo;
          geo = geo.replace('POINT(','').replace(')','');
          const point = geo.split(' ');
          const arr = [Number(point[0]),Number(point[1])];
          setCenterPoint(arr);
          let pointObj = new window.BMap.Point(arr[0],arr[1]);
          map.centerAndZoom(pointObj,15);
          // 添加标记
          let icon = new window.BMap.Icon(markIcon,new window.BMap.Size(32,32),{
            imageSize: new window.BMap.Size(32,32),
            anchor: new window.BMap.Size(16,16)
          })
          map.addOverlay(new window.BMap.Marker(pointObj,{icon:icon}));
          let label = new window.BMap.Label(instanceData?.instanceName, {       // 创建文本标注
              position: pointObj,                          // 设置标注的地理位置
              offset: new window.BMap.Size(10, 10)           // 设置标注的偏移量
          })  
          label.setStyle({                              // 设置label的样式
            color: '#E35B45',
            fontSize: '16px',
            border: 'none',
            background:'none',
            marginLeft: '-40px',
            marginTop: '15px'
          })
          map.addOverlay(label); 
        }else{
          setHasMap(false);
        }   
      })
    },500);
  },[map]);

  // 放大
  const mapZoomOut = () => {
    map.zoomTo(map.getZoom()+1);
  }

  // 缩小
  const mapZoomIn = () => {
    let zoom = map.getZoom();
    if(zoom>1){
      map.zoomTo(map.getZoom()-1);
    }
  }

  // 返回主位置
  const mapBack = () => {
    map.centerAndZoom(new window.BMap.Point(centerPoint[0],centerPoint[1]),15);
  }

  //  查询图片所属实例信息
  const getInstanceDetail = () => {
    queryInstanceDetails({
      attrEnglishCodes: [],
      instanceId: instanceId
    }).then((res) => {
      if (res) {
        // 获取基本信息的前六个字段进行展示
        res['attrs'] = [];
        let count = 0;
        res?.attrFields?.map((item,index) => {
            let name;
            res?.attrTriples?.forEach(i => {
                if (i.englishCode == item) {
                    name = i.relationshipName;
                }
            })
            const val = res?.properties[item];
            if(name && count<=5){
                count += 1;
                // 如果是地理位置：先判断地名是否存在，不存在就取地名备注
                if(item == 'currentLocation'){
                  if(val){
                    res['attrs'].push({name:name,val:val});
                  }else{
                    const val1 = res?.properties['currentLocationBZ'];
                    res['attrs'].push({name:name,val:val1 ? val1 : '不详'});
                  }
                }else{
                  res['attrs'].push({name:name,val:val ? val : '不详'});
                }
            }
        })
        setInstanceData(res);
        // 配置其他影像模块
        let fileArr = Array.isArray(res.files) ? res.files : [];
        fileArr = fileArr?.filter(item => {
          return item?.fileCategory === 'FILE_TYPE_PICTURE' && item?.fileInfoId != fileInfoId;
        })
        if(fileArr.length>0){
          let num = Math.ceil(fileArr.length / 8);
          let arr = [];
          for(let i=0;i<num;i++){
            if(i == num.length -1){
              arr.push(fileArr.slice(i*8,fileArr.length));
            }else{
              arr.push(fileArr.slice(i*8,(i+1)*8));
            }
          }
          setHasImg(true);
          setImgs(arr);
        }else{
          setHasImg(false);
          setImgs([]);
        }
        //  查询推荐实例信息
        getRecommendInstance(res);
        // 地图初始化
        if(res.conceptCode == 'AncientBuilding'){
          let mapEl = new window.BMap.Map("mapContainer");
          setMap(mapEl);
        }else{
          setHasMap(false);
        }
      }
    });
  }

  //  查询推荐实例信息
  const getRecommendInstance = (res) => {
    queryRecommendedImageList({
      current: 1,
      size: 50,
      conceptCodes: [res.conceptCode],
      instanceId: res.instanceId,
      instanceName: res.instanceName
    }).then((data) => {
      // 配置推荐实例模块
      if(data.records.length>0){
        let imgArr = data.records;
        let num = Math.ceil(imgArr.length / 5);
        let arr = [];
        for(let i=0;i<num;i++){
          if(i == num.length -1){
            arr.push(imgArr.slice(i*5,imgArr.length));
          }else{
            arr.push(imgArr.slice(i*5,(i+1)*5));
          }
        }
        if(arr.length>0){
          setImgs1(arr);
        }
      }
    });
  }
  return (
    <div className='rootDiv'>
      {/* 顶部大图展示组件 */}
      <BigImgShow isInitImg={isInitImg}/>
      {/* 实例信息 */}
      { instanceData && instanceData.properties &&
        <div className='centerDiv'>
          <div className='module'>
            <div className='head'>
              <span className='title'>{instanceData?.instanceName}</span>
              <Link to={`/Subject/HistoricalBuilding/${instanceData?.instanceId}`} target='_blank' className="instance-link">
                查看详情
                <span className="icon iconfont icon-you"/>
              </Link>
            </div>
            <div className='desc' dangerouslySetInnerHTML={{
            __html: instanceData?.properties?.description
            }} />
            {/* tab切换 */}
            <ul className={cls('tab',{notHasImg:!hasImg},{notHasMap:!hasMap})}>
              {tab?.map((item, index) => {
                return (
                  <li className={cls(item.id,{active:item.id == selectedTab})} key={index} onClick={()=>{
                    setSelectedTab(item.id);
                    setInit(false);
                    if(item.id == 'map' && hasMap){
                      setTimeout(()=>{mapBack();},500);
                    }
                  }}>{item.text}</li>
                )
              })}
            </ul>
            <div className='tabContent'>
              {/* 基本信息 */}
              <div className={cls('tabItem','basicInfo',{show:selectedTab=='basicInfo'})}>
                {
                    instanceData?.attrs?.map((item,index) => {
                        return (
                            <div className='row' key={index}>
                              <span className='key'>{item.name}：</span>
                              <span className='value'>{item.val}</span>
                            </div>
                          )
                    })
                }
                {/* <div className='row'>
                  <span className='key'>正名：</span>
                  <span className='value'>{instanceData?.properties.title || instanceData?.properties.name || '不详'}</span>
                </div>
                <div className='row'>
                  <span className='key'>别名：</span>
                  <span className='value'>{instanceData?.properties.alias || '不详'}</span>
                </div>
                <div className='row'>
                  <span className='key'>类型：</span>
                  <span className='value'>{instanceData?.properties.type || '不详'}</span>
                </div>
                <div className='row'>
                  <span className='key'>地点：</span>
                  <span className='value'>{instanceData?.properties.currentLocation || '不详'}</span>
                </div>
                <div className='row'>
                  <span className='key'>创建者：</span>
                  <span className='value'>{instanceData?.properties.creator || '不详'}</span>
                </div>
                <div className='row'>
                  <span className='key'>年代：</span>
                  <span className='value'>{instanceData?.properties.creationDate || '不详'}</span>
                </div> */}
              </div>
              {/* 关系图谱 */}
              <div className={cls('tabItem','relationGraph',{show:selectedTab=='relationGraph'},{init: init})}>
                <Relation id={instanceId}/>
                <Link className='fullscreen' to={`/Relation?centersearch=${instanceData?.instanceName}`} target="_blank">
                  <img src={fullscreenImg} />
                </Link>
              </div>
              {/* 地理位置 */}
              <div className={cls('tabItem','map',{show:selectedTab=='map'},{init: init})}>
                <p>
                  <span>{instanceData?.properties.currentLocation}</span>
                  <span>经纬度：{instanceData?.properties.coordinate}</span>
                  {/* <span>经度：118.285227</span>
                  <span>经度：118.285227</span> */}
                </p>
                <div id='mapContainer'/>
                <div className='mapTool'>
                  <div id='mapZoomOut' onClick={()=>mapZoomOut()} />
                  <div id='mapZoomIn' onClick={()=>mapZoomIn()} />
                  <div id='mapBack' onClick={() =>mapBack()}/>
                </div>
              </div>
              {/* 其他影像 */}
              <div className={cls('tabItem','resource',{show:imgs.length>0 && selectedTab=='resource'})}>
                <Slider {...settings}>
                  {imgs.map((item, index) => {
                    return (
                      <div className="resource-item" key={index}>
                        {
                          item.map((item1,index1) => {
                            return (
                              <Link to={`/PicturelistPage/${instanceId}?fileInfoId=${item1?.fileInfoId}&hasMark=${item1?.markSum ? '1' : '0'}`} className={cls('imgBox',{'mark':item1.markSum})} key={index1} target="_blank">
                                <img src={item1.fileThumbnail ? `${pre}/${item1.fileThumbnail}` : dImg} />
                                {item1.markSum ? <img className='markImg' src={markImg}/> : ''}
                              </Link>
                            )
                          })
                        }
                      </div>
                    )
                  })}
                </Slider>
              </div>
            </div>
          </div>
          {imgs1.length>0 && <div className='module'>
            <div className='head'>
              <span className='title'>相关推荐</span>
            </div>
            <div className='recommend'>
              <Slider {...settings}>
                {imgs1.map((item, index) => {
                  return (
                    <div className="recommend-item" key={index}>
                      {
                        item.map((item1,index1) => {
                          return (
                            <Link to={`/Subject/HistoricalBuilding/${item1.instanceId}`} target="_blank" key={index1}>
                              <img src={item1.showImage ? `${pre}/${item1.showImage}` : dImg} />
                              <p>{item1.instanceName}</p>
                            </Link>
                          )
                        })
                      }
                    </div>
                  )
                })}
              </Slider>
            </div>
          </div>}
        </div>
      }
    </div>
  );
};
export default ImgDetail;
